import React from 'react'
import { SlReload } from 'react-icons/sl';
import EditIcon from "../../../../media/icons/assets_light/outline-message-edit-active.svg";

import DeleteIcon from '../../../../media/icons/assets_light/outline-action-delete-active.svg';
import SettingIcon from '../../../../media/icons/assets_light/outline-management-settings-active.svg';
import RoomIcon from '../../../../media/icons/assets_light/outline-rooms-chat-active.svg';
import ProjectIcon from '../../../../media/icons/assets_light/outline-rooms-project-active.svg';
import NotificationIcon from '../../../../media/icons/assets_light/outline-management-notification-active.svg';
import { useSelector } from 'react-redux';
import { useTaskContext } from '../../../../context/TaskContext';

export default function TaskMenu({
    optionsRef,
    setTaskOptions,
    setTaskDeletePopup,
    setEditingTaskTitle,
    setEditingTaskTitleText,
    setRoomSelectPopup,
    setProjectPopup,
    setShowNotifications }) {

    const { user } = useSelector(state => state.message)
    const { delete_task, OnUpdateTask, selectedTask, isObserver, isAssignee } = useTaskContext();
    const { active_task } = useSelector((state) => state.task);

    return (

        <ul
            ref={optionsRef}
            className="userActionPopup !absolute !p-0 !py-2 !top-[85px] !right-4 !z-20 !w-[200px]"
        >
            {active_task?.created_by === user?.id &&
                <li onClick={() => { setEditingTaskTitle(true); setEditingTaskTitleText(active_task?.task_title); setTaskOptions(false); }} className={`!flex items-center gap-2 px-4 py-2 text-sm cursor-pointer text-text-body dark:text-white hover:bg-[#f1f2f4] dark:hover:bg-surface-panel`} >
                    <div

                        className="relative top-[0px] left-[0px] w-[16px] h-[16px] bg-[#636E82] dark:!bg-white hover:bg-text-text-action cursor-pointer"
                        style={{
                            WebkitMaskImage: `url(${EditIcon})`,
                            WebkitMaskRepeat: 'no-repeat',
                            WebkitMaskPosition: 'center',
                            WebkitMaskSize: 'contain',
                            maskImage: `url(${EditIcon})`,
                            maskRepeat: 'no-repeat',
                            maskPosition: 'center',
                            maskSize: 'contain',
                        }}
                    />
                    <div className='text-sm text-text-body dark:text-white hover:bg-text-text-action'>Edit</div>
                </li>
            }
            {user?.id === active_task?.created_by &&
                <li onClick={() => { setTaskDeletePopup(true); setTaskOptions(false); }} className={`!flex items-center gap-2 px-4 py-2 text-sm cursor-pointer text-text-body dark:text-white hover:bg-[#f1f2f4] dark:hover:bg-surface-panel`} >
                    <div

                        className="relative top-[0px] left-[0px] w-[16px] h-[16px] bg-[#636E82] dark:!bg-white hover:bg-text-text-action cursor-pointer"
                        style={{
                            WebkitMaskImage: `url(${DeleteIcon})`,
                            WebkitMaskRepeat: 'no-repeat',
                            WebkitMaskPosition: 'center',
                            WebkitMaskSize: 'contain',
                            maskImage: `url(${DeleteIcon})`,
                            maskRepeat: 'no-repeat',
                            maskPosition: 'center',
                            maskSize: 'contain',
                        }}
                    />
                    <div className='text-sm text-text-body dark:text-white hover:bg-text-text-action'>Delete</div>
                </li>
            }
            <li onClick={() => { setTaskOptions(false); }} className={`!flex items-center gap-2 px-4 py-2 text-sm cursor-pointer text-text-body dark:text-white hover:bg-[#f1f2f4] dark:hover:bg-surface-panel`} >
                <div

                    className="relative top-[0px] left-[0px] w-[16px] h-[16px] bg-[#636E82] dark:!bg-white hover:bg-text-text-action cursor-pointer"
                    style={{
                        WebkitMaskImage: `url(${SettingIcon})`,
                        WebkitMaskRepeat: 'no-repeat',
                        WebkitMaskPosition: 'center',
                        WebkitMaskSize: 'contain',
                        maskImage: `url(${SettingIcon})`,
                        maskRepeat: 'no-repeat',
                        maskPosition: 'center',
                        maskSize: 'contain',
                    }}
                />
                <div className='text-sm text-text-body dark:text-white hover:bg-text-text-action'>Task Management</div>
            </li>
            {((!isObserver() && !isAssignee()) || active_task?.created_by === user?.id) &&
                <li onClick={() => { setTaskOptions(false); }} className={`!flex items-center gap-2 px-4 py-2 text-sm cursor-pointer text-text-body dark:text-white hover:bg-[#f1f2f4] dark:hover:bg-surface-panel`} >
                    <div

                        className="relative top-[0px] left-[0px] w-[16px] h-[16px] bg-[#636E82] dark:!bg-white hover:bg-text-text-action cursor-pointer"
                        style={{
                            WebkitMaskImage: `url(${RoomIcon})`,
                            WebkitMaskRepeat: 'no-repeat',
                            WebkitMaskPosition: 'center',
                            WebkitMaskSize: 'contain',
                            maskImage: `url(${RoomIcon})`,
                            maskRepeat: 'no-repeat',
                            maskPosition: 'center',
                            maskSize: 'contain',
                        }}
                    />
                    <div onClick={() => setRoomSelectPopup(true)} className='text-sm text-text-body dark:text-white hover:bg-text-text-action'>Change room</div>
                </li>
            }
            <li onClick={() => { setProjectPopup(true); setTaskOptions(false); }} className={`!flex items-center gap-2 px-4 py-2 text-sm cursor-pointer text-text-body dark:text-white hover:bg-[#f1f2f4] dark:hover:bg-surface-panel`} >
                <div

                    className="relative top-[0px] left-[0px] w-[16px] h-[16px] bg-[#636E82] dark:!bg-white hover:bg-text-text-action cursor-pointer"
                    style={{
                        WebkitMaskImage: `url(${ProjectIcon})`,
                        WebkitMaskRepeat: 'no-repeat',
                        WebkitMaskPosition: 'center',
                        WebkitMaskSize: 'contain',
                        maskImage: `url(${ProjectIcon})`,
                        maskRepeat: 'no-repeat',
                        maskPosition: 'center',
                        maskSize: 'contain',
                    }}
                />
                <div className='text-sm text-text-body dark:text-white hover:bg-text-text-action'>Change project</div>
            </li>
            <li onClick={() => { setShowNotifications(true); setTaskOptions(false) }} className={`!flex items-center gap-2 px-4 py-2 text-sm cursor-pointer text-text-body dark:text-white hover:bg-[#f1f2f4] dark:hover:bg-surface-panel`} >
                <div

                    className="relative top-[0px] left-[0px] w-[16px] h-[16px] bg-[#636E82] dark:!bg-white hover:bg-text-text-action cursor-pointer"
                    style={{
                        WebkitMaskImage: `url(${NotificationIcon})`,
                        WebkitMaskRepeat: 'no-repeat',
                        WebkitMaskPosition: 'center',
                        WebkitMaskSize: 'contain',
                        maskImage: `url(${NotificationIcon})`,
                        maskRepeat: 'no-repeat',
                        maskPosition: 'center',
                        maskSize: 'contain',
                    }}
                />
                <div className='text-sm text-text-body dark:text-white hover:bg-text-text-action'>Notifications</div>
            </li>
            <li className={`!flex items-center gap-2 px-4 py-2 text-sm cursor-pointer text-text-body dark:text-white hover:bg-[#f1f2f4] dark:hover:bg-surface-panel`} >
                <SlReload className='text-[#636E82] dark:text-white' size={14} />
                <div onClick={() => { setTaskOptions(false) }} className='text-sm text-text-body dark:text-white hover:bg-text-text-action'>History</div>
            </li>
        </ul>
    )
}
